/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import {
  GetBookedCourtDetail,
  GetPdfHtmlForPrint,
} from "../../../utilities/api/courtBooking";
import { toast } from "react-toastify";
import { useLocation } from "react-router";
import { QRCodeSVG } from "qrcode.react";
import { images } from "../../../config/images";
import { CheckReschedule, LableFromEnums } from "../../../utilities";
import { useNavigate } from "react-router-dom";

const CustomerCourtBookingDetails = (props: any) => {
  const navigate = useNavigate();
  const { Enums } = useAppSelector((state) => state.enumsArray);
  const [totalTax, setTotalTax] = useState(0);
  const [printing, setPrinting] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({}) as any;
  const { newRef } = props;
  const id = useLocation().state;
  const ComponentRef = useRef<HTMLDivElement>(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const { AllFacilitiesData, errorMessage } = useAppSelector((state) => state.facilityList);
  const facilityAddress = AllFacilitiesData.find(
    (item: any) => item.id == bookingDetails.facilityId
  )?.address as string;

  if (errorMessage) {
    toast.error(errorMessage.message)
  }
  const GetData = async () => {
    const result = await GetBookedCourtDetail(id);
    if (result?.statusCode === 200) {
      setBookingDetails(result.data);
      let getTotalTax = 0;

      result.data?.bookingTaxes.forEach((_tax: any) => {
        getTotalTax += _tax?.percentage;
      });

      setTotalTax(getTotalTax);
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetData();
  }, [ComponentRef]);

  const handlePrint = () => {
    setPrinting(true);
    window.open(
      "/printing/?type=invoice&prefix=CB&id=" + bookingDetails.id + "&hash=" + bookingDetails?.hash,
      "_blank"
    );
    setTimeout(() => {
      setPrinting(false);
    }, 2000);
  };

  const handleInvoice = async (e: any) => {
    setButtonDisable(true);
    e.preventDefault();
    const result = await GetPdfHtmlForPrint("invoice", bookingDetails?.hash);
    if (result.statusCode === 200) {
      window.open("/printing/?type=invoice&prefix=CB&id=" + bookingDetails.id + "&hash=" + bookingDetails?.hash, "_blank");
    } else {
      toast.error(result.response.data.message);
    }
    setButtonDisable(false);
  };

  const getFormatedDate = (_date: string) => {
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return `${_mm}/${_dd}/${_yy}`;
  };

  let actionColumn = bookingDetails?.bookingSlots?.reduce(
    (acc: any, cur: any) =>
      acc.bookingDate > cur.bookingDate && acc?.fromTime > cur?.fromTime
        ? acc
        : cur
  );

  const handleEdit = (data: any) => {
    navigate("/customer-court-booking-reschedule", {
      state: {
        ...data,
        slotId: data.id,
        facilityId: bookingDetails.facilityId,
        sportId: bookingDetails.sportId,
        courtId: bookingDetails.courtId,
        id: id,
      },
    });
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="mb-0">Booking Details</Card.Title>
              <Button
                onClick={handlePrint}
                type="button"
                className="btn btn-light rounded-1 me-3"
                bname={printing ? "Printing" : "Print"}
                name="print"
                id="print"
                disabled={printing}
              ></Button>
            </div>
            <div ref={newRef ? newRef : ComponentRef} className="print-content">
              <Row>

                <Col lg={12} className="row-mb">
                  <div className="align-items-center d-flex flex-column pt-3">
                    <div className="qr-img">
                      <QRCodeSVG
                        value={JSON.stringify(bookingDetails?.id)}
                        size={200}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"L"}
                        includeMargin={false}
                        imageSettings={{
                          src: images.powerplayicon.default,
                          x: undefined,
                          y: undefined,
                          height: 30,
                          width: 30,
                          excavate: true,
                        }}
                      />
                    </div>
                    <small className="text-uppercase text-muted mt-3">
                      {bookingDetails?.user?.firstName}{" "}
                      {bookingDetails?.user?.lastName}
                    </small>
                    <span className="fw-semibold ">
                      {bookingDetails?.user?.phone}
                    </span>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="coach-booking-details">
                    <Row className="text-start row-mb gy-4">
                      <Col lg={3}>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Facility Name
                        </span>
                        <span className="user-info">
                          {bookingDetails?.facilityName}
                        </span>
                      </Col>
                      <Col lg={3}>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Sports
                        </span>
                        <span className="user-info">
                          {bookingDetails?.sportName}
                        </span>
                      </Col>
                      <Col lg={3}>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Court Name
                        </span>
                        <span className="user-info">
                          {bookingDetails?.courtName}
                        </span>
                      </Col>
                      <Col lg={3}>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Booking Status
                        </span>
                        <span className="user-info">
                          {LableFromEnums(bookingDetails?.status, Enums)}
                        </span>
                      </Col>
                      <Col lg={12}>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Facility Address
                        </span>
                        <span className="user-info">{facilityAddress}</span>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={12}>
                  <h4 className="fs-5 fw-bold text-start">Selected Slots</h4>
                  <table className="table table-bordered table-sm ">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Day</th>
                        <th>Time</th>
                        <th>Amount</th>
                        <th>Status</th>
                        {!CheckReschedule(
                          `${getFormatedDate(actionColumn?.bookingDate)} ${actionColumn?.fromTime
                          }`
                        ) && <th>Action</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {bookingDetails?.bookingSlots?.map((item: any) => {
                        return (
                          <tr key={item.fromTime}>
                            <td>{item.bookingDate}</td>
                            <td>{item.bookingDay}</td>
                            <td>
                              {item.fromTime} to {item.toTime}
                            </td>
                            <td>{item.ratePerSlot}</td>
                            <td>{LableFromEnums(item.status, Enums)}</td>
                            {!CheckReschedule(
                              `${getFormatedDate(actionColumn.bookingDate)} ${actionColumn.fromTime
                              }`
                            ) && (
                                <td>
                                  <Button
                                    onClick={() => handleEdit(item)}
                                    disabled={
                                      item.status === "cancelled" ||
                                      bookingDetails?.status === "cancelled" ||
                                      CheckReschedule(
                                        `${getFormatedDate(item.bookingDate)} ${item.fromTime}`
                                      )
                                    }
                                    type="button"
                                    bname="Reschedule"
                                    name="Reschedule"
                                    id={"edit-slot" + item.id}
                                    className="btn btn-sm btn-outline-primary px-4 rounded-1"
                                  ></Button>
                                </td>
                              )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Col>
              </Row>
              <Row className="text-end">
                <hr />
                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Slot(s) Price :{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails?.subTotal?.toFixed(2)}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Total Tax({totalTax}%) :{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails?.totalTax?.toFixed(2)}
                  </span>
                </Col>

                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Total Amount to Pay :{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails?.totalAmount?.toFixed(2)}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Total Paid Amount :{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(bookingDetails?.totalPaidAmount)}
                  </span>
                </Col>
                <Col lg={12}>
                  <span className="d-block fst-italic fw-semibold mt-3">
                    <sup>*</sup>The Amount is inclusive of all the taxes
                  </span>
                </Col>
              </Row>
            </div>
            {bookingDetails?.status === "completed" && (
              <>
                <hr />
                <Row>
                  <Col lg={12} className="text-end">
                    <Button
                      disabled={buttonDisable}
                      onClick={handleInvoice}
                      type="button"
                      bname={
                        buttonDisable ? "Downloading..." : "Download Invoice"
                      }
                      name="downaload"
                      id="download"
                      className="btn btn-primary rounded-1"
                    ></Button>
                  </Col>
                </Row>
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { CustomerCourtBookingDetails };
